import qs from 'qs';

export const PATH = {
  // invite: '/invite',
  invite: '/home',
  default: '/home',
};
export const BASE_URL = process.env.REACT_APP_SCRATCH_URL;

export const getUrl = (path: string, params: Record<string, string>) => {
  const queryString = qs.stringify(params);
  return `${BASE_URL}${path}?${queryString}`;
};

export const enum EventType {
  LOGIN = 'login',
  BACK = 'back',
  EXIT = 'exit',
  SHARE = 'share',
  DOWNLOAD_APP = 'downloadApp',
}
